/**
 * Decorative SVG patterns inspired by West-African Adinkra and Kente motifs.
 * Used as subtle background accents across the landing page.
 */

export function KenteBorder({ className = "" }) {
  return (
    <svg
      viewBox="0 0 1200 24"
      preserveAspectRatio="none"
      className={className}
      aria-hidden="true"
    >
      <pattern id="kente" x="0" y="0" width="48" height="24" patternUnits="userSpaceOnUse">
        <rect width="48" height="24" fill="transparent" />
        <path d="M0 12 L12 0 L24 12 L36 0 L48 12 L36 24 L24 12 L12 24 Z" fill="#B8862D" opacity="0.85" />
        <circle cx="6" cy="12" r="1.5" fill="#2B1F12" />
        <circle cx="42" cy="12" r="1.5" fill="#2B1F12" />
      </pattern>
      <rect width="1200" height="24" fill="url(#kente)" />
    </svg>
  );
}

export function AdinkraDots({ className = "", color = "#B8862D" }) {
  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <pattern id="adinkra-dots" x="0" y="0" width="32" height="32" patternUnits="userSpaceOnUse">
          <circle cx="4" cy="4" r="1.2" fill={color} opacity="0.45" />
          <circle cx="20" cy="20" r="1.2" fill={color} opacity="0.45" />
          <path d="M16 8 L20 12 L16 16 L12 12 Z" fill={color} opacity="0.25" />
        </pattern>
      </defs>
      <rect width="200" height="200" fill="url(#adinkra-dots)" />
    </svg>
  );
}

export function KenteStripes({ className = "" }) {
  return (
    <svg
      viewBox="0 0 12 200"
      preserveAspectRatio="none"
      className={className}
      aria-hidden="true"
    >
      <rect x="0" y="0" width="12" height="200" fill="#FAF9F6" />
      <rect x="2" y="0" width="2" height="200" fill="#B8862D" />
      <rect x="6" y="0" width="1" height="200" fill="#2B1F12" />
      <rect x="9" y="0" width="2" height="200" fill="#D4A04E" />
    </svg>
  );
}

export function AdinkraSymbol({ size = 40, color = "#B8862D", className = "" }) {
  // "Gye Nyame" - power of God, a sacred Adinkra symbol
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <g fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M32 8 Q44 8 48 20 Q52 32 44 40 Q36 48 24 44" />
        <path d="M32 8 Q20 8 16 20 Q12 32 20 40 Q28 48 40 44" />
        <circle cx="32" cy="32" r="4" fill={color} />
        <path d="M32 50 L32 56" />
        <path d="M28 53 L32 50 L36 53" />
      </g>
    </svg>
  );
}

export function PatternDivider() {
  return (
    <div className="flex items-center justify-center gap-3 my-2" aria-hidden="true">
      <div className="h-px w-12 bg-terracotta/30" />
      <div className="flex gap-1">
        <span className="block h-2 w-2 rotate-45 bg-terracotta/60" />
        <span className="block h-2 w-2 rotate-45 bg-[#D4A04E]/70" />
        <span className="block h-2 w-2 rotate-45 bg-terracotta/60" />
      </div>
      <div className="h-px w-12 bg-terracotta/30" />
    </div>
  );
}
